import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-video-dialog',
    templateUrl: './video-dialog.component.html',
    styleUrls: ['./video-dialog.component.scss'],
    standalone: false
})
export class VideoDialogComponent implements OnInit {

  safeResourceUrl: SafeResourceUrl;
  private readonly autoplayQueryParams = '?autoplay=1&loop=1';

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private sanitizer: DomSanitizer) {
    this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.videoHref + this.autoplayQueryParams);
  }

  ngOnInit(): void {
  }

}
